export const getMessage = state => state.forgotPassword.message
export const getLoading = state => state.forgotPassword.loading
export const getMessageType = state => state.forgotPassword.messageType
